import { useEffect } from 'react';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';

const { store: mixpanelStore } = marketplaceIntegration;

export const useTracking = ({ listingsType, searchQuery }) => {
    useEffect(() => {
        mixpanelStore.listingsType.setData(listingsType);
        mixpanelStore.searchQuery.setData(searchQuery);
        mixpanelStore.sourcePage.setData(
            searchQuery ? 'Search' : 'Subcategory'
        );
    }, [listingsType, searchQuery]);
};
